import PortalIdParser from 'PortalIdParser';
import Enviro from 'enviro';
export const getFeatureReleaseUrl = () => `/settings/${PortalIdParser.get()}/account-defaults/feature-releases`;
export const getPricingUrl = () => Enviro.isQa() ? `https://app.hubspotqa.com/pricing/${PortalIdParser.get()}` : `https://app.hubspot.com/pricing/${PortalIdParser.get()}`;